// Use REACT_APP_BASE_URL from environment when provided (set in .env),
// otherwise fall back to the production API host. The exported BASEURL
// will always include the `/api` suffix.
const _envBase = process.env.REACT_APP_BASE_URL || "https://admin.pmcbd.net";
export const BASEURL = _envBase.endsWith("/api") ? _envBase : `${_envBase.replace(/\/$/, "")}/api`;

export const APP_VERSION = '0.0.1'
